import React, { useState } from "react";
import BottomAppBar from "../components/BottomBar";
import Navigation from "../components/Navigation";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { faLaptopHouse } from "@fortawesome/free-solid-svg-icons";
import Loader from "../components/loaders/Loader";
const { innerWidth: width } = window;

const WebLink = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { link, type, title , color } = state;
  const [loading, setLoading] = useState(faLaptopHouse);
  // const [numPages, setNumPages] = useState(null);

  // function onDocumentLoadSuccess({ numPages }) {
  //   setNumPages(numPages);
  // }
  const checkImg = () => {
    let extension = link.slice(-3);
    if (extension === "pdf") return false;
    else return true;
  };


  if (type === "website")
    return (
      <>
        <Navigation title={title || t("DETAIL")} appBarColor={color || "orange"} />
        <div className="fixed-layout-main flex">
          <>
            {loading && (
              <div className=" fixed-layout-main bg-white w-screen flex flex-1 justify-center items-center">
                <Loader />
              </div>
            )}
            <div className={`${loading ? "hidden" : "block"}`}>
              <div className="fixed-layout-main flex ">
                <iframe
                  onLoad={() => setLoading(false)}
                
                  width={width}
                  src={
                    link
                  }
                  title="myFrame"
                ></iframe>
              </div>
            </div>
          </>
        </div>
        <BottomAppBar />
      </>
    );

  return (
    <>
      <Navigation title={state?.title || t("DETAIL")} appBarColor={color || "orange"}  />
      <div className="fixed-layout-main flex">
        {checkImg() ? (
          <img src={link} alt={link} className="w-full" />
        ) : (
          <>
            {loading && (
              <div className=" fixed-layout-main bg-white w-screen flex flex-1 justify-center items-center">
                <Loader />
              </div>
            )}
            <div className={`${loading ? "hidden" : "block"}`}>
              <div className="fixed-layout-main flex ">
                <iframe
                  onLoad={() => setLoading(false)}
                  className=""
                  width={width}
                  src={
                    "https://drive.google.com/viewerng/viewer?embedded=true&url=" +
                    link
                  }
                  title="myFrame"
                ></iframe>
              </div>
            </div>
          </>

          // <Document
          //   file={link}
          //   className="w-screen object-contain"
          //   width={300}
          //   loading={
          //     <div className=" fixed-layout-main bg-white w-screen flex flex-1 justify-center items-center">
          //       Loading...
          //     </div>
          //   }
          //   error={
          //     <div className=" fixed-layout-main bg-white w-screen flex flex-1 justify-center items-center">
          //       Error occured while loading pdf.
          //     </div>
          //   }
          //   onLoadSuccess={onDocumentLoadSuccess}
          // >
          //   {Array.from(new Array(numPages), (el, index) => (
          //     <Page
          //       className="w-full"
          //       key={`page_${index + 1}`}
          //       pageNumber={index + 1}
          //     />
          //   ))}
          // </Document>
        )}
      </div>
      <BottomAppBar />
    </>
  );
};

export default WebLink;
